import React, { FC } from 'react';
import { Field } from '@chakra-ui/react';
import { HelpTextProps } from './types';

export const HelpText: FC<HelpTextProps> = ({ children, ...rest }) => {
  return <Field.HelperText {...rest}>{children}</Field.HelperText>;
};

HelpText.displayName = 'HelpText';
